import React, { useRef, useEffect } from "react";

const DraggableHandle = ({
  id,
  x,
  y,
  onMouseDown,
  color = "#f06633",
  size = 12,
}) => {
  const handleRef = useRef(null);

  // Register touch events as non-passive to allow preventDefault
  useEffect(() => {
    const handleElement = handleRef.current;
    if (!handleElement || !onMouseDown) return;

    const touchStartHandler = (e) => {
      // Prevent default touch behavior and call the same handler
      e.preventDefault();
      onMouseDown(e, id);
    };

    // Register as non-passive so preventDefault works
    handleElement.addEventListener('touchstart', touchStartHandler, { 
      passive: false 
    });

    return () => {
      handleElement.removeEventListener('touchstart', touchStartHandler);
    };
  }, [id, onMouseDown]);

  return (
    <div
      ref={handleRef}
      role="button"
      tabIndex={0}
      aria-label={`Draggable handle ${id + 1}`}
      onMouseDown={(e) => onMouseDown(e, id)}
      // Don't use onTouchStart here - we handle it with addEventListener above
      className="position-absolute rounded-circle shadow cursor-grab"
      style={{
        left: `${x - size / 2}px`,
        top: `${y - size / 2}px`,
        width: `${size}px`,
        height: `${size}px`,
        backgroundColor: color,
        touchAction: "none", // Prevents default touch behaviors
      }}
    />
  );
};

export default DraggableHandle;